'use client'
import React, { useContext } from 'react';
import { Text } from '@chakra-ui/layout';
import { Icon, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { MdMoreHoriz, MdOutlineDelete } from 'react-icons/md';
import roleDictionnary from '@/lib/roleDictionnary';
import { useDisclosure } from '@chakra-ui/react-use-disclosure';
import { ProductContext } from '../../lib/productContext';
import DeleteProductModal from '../../components/deleteProductModal';
import { ProductPageContext } from '../lib/productPageContext';
export default function ProductAsideEditMenu(props) {
  const {
    product,
    role,
    rights,
  } = useContext(ProductContext);
  const {
    setEditingMainFeatures,
    setEditingTypes,
    setEditingValueProposition,
    setEditingUsefulLinks
  } = useContext(ProductPageContext);
  const modalDelete = useDisclosure();
  return (
    <>
      {(product && (role && role !== roleDictionnary.viewer)) && (
        <>
          <Menu>
            {({ isOpen }) => (
              <>
                <MenuButton
                  isActive={isOpen}
                  as={IconButton}
                  icon={<MdMoreHoriz />}
                  variant='purpleOutline'
                />
                <MenuList>
                  {!product.value_proposition &&
                    <MenuItem onClick={() => {
                      setEditingValueProposition(true);
                    }}>
                      Add Value Proposition
                    </MenuItem>
                  }
                  {!product.types &&
                    <MenuItem onClick={() => {
                      setEditingTypes(true);
                    }}>
                      Add Product Types
                    </MenuItem>
                  }
                  {(!product.features || product.features.length === 0) &&
                    <MenuItem onClick={() => {
                      setEditingMainFeatures(true);
                    }}>
                      Add Main Features
                    </MenuItem>
                  }
                  {(!product.useful_links || product.useful_links.length === 0) &&
                    <MenuItem onClick={() => {
                      setEditingUsefulLinks(true);
                    }}>
                      Add Useful Links
                    </MenuItem>
                  }
                  {rights.can_delete && (
                    <MenuItem onClick={() => {
                      modalDelete.onOpen();
                    }}>
                        <Icon
                        as={MdOutlineDelete}
                        color='text.medium.red'
                        boxSize={'14px'}
                        mr={2}
                      />
                      <Text color='text.medium.red' >Delete</Text>
                      <DeleteProductModal disclosure={modalDelete} />
                    </MenuItem>
                  )}
                </MenuList>
              </>
            )}
          </Menu>
        </>
      )}
    </>
  )
}
